const formations = [
  {
    label: "Biotechnologies & Management",
    value: "Biotechnologie"
  },
  {
    label: "Énergie & Management", 
    value: "Energie"
  },
  {
    label: "Digital & Management",
    value: "Digital"
  },
  {
    label: "Informatique & Management",
    value: "Informatique"
  }
]

export const getMscQueryParamName = (formation) => {
  switch (formation) {
    case "Biotechnologie":
      return "biotechnologies"
    case "Energie":
      return "energie"
    case "Digital":
      return "tic"
    case "Informatique":
      return "informatique"
    default:
      return null
  }
}

export default formations